import './InputField.scss';

import SkapaInputField, { InputFieldProps as SkapaInputFieldProps } from '@ingka/input-field';
import { RefAttributes } from 'react';

import { PREFIX } from '../constants/constants';

const InputField = (
  props: SkapaInputFieldProps & RefAttributes<HTMLInputElement> & { autoComplete?: string; name?: string },
) => <SkapaInputField prefix={PREFIX} {...props} />;

export default InputField;
